import 'twin.macro';
import React from 'react';
import { EmptyState, PortableText } from '../components/elements';

import HomeHero from '../components/home/HomeHero';
import FeaturedProduct from '../components/product/FeaturedProduct';
import Collection from '../components/collection/Collection';
import AllCategories from '../components/category/AllCategories';
import BrochureBlock from '../components/contact/BrochureBlock';
import ServiceOption from '../components/service/ServiceOption';
import FeaturedServices from '../components/service/FeaturedServices';
import AllServices from '../components/service/AllServices';
import LatestNews from '../components/blog/LatestNews';
import AllNews from '../components/blog/AllNews';
import ReviewBlock from '../components/review/ReviewBlock';
import AboutBlock from '../components/about/AboutBlock';
import InfoBlock from '../components/about/InfoBlock';
import BrandBlock from '../components/brand/BrandBlock';
import SubscribeForm from '../components/contact/SubscribeForm';
import ContactBlock from '../components/contact/ContactBlock';
import Announcement from '../components/global/Announcement';
import Questions from '../components/faq/Questions';
import ServiceLevels from '../components/service/ServiceLevels';

// sanity blocks
const Blocks = {
  heroBlock: HomeHero,
  featuredProduct: FeaturedProduct,
  serviceOption: ServiceOption,
  subscribeBlock: SubscribeForm,
  additionalService: FeaturedServices,
  latestNewsSection: LatestNews,
  reviewBlock: ReviewBlock,
  collectionBlock: Collection,
  allNewsSection: AllNews,
  aboutBlock: AboutBlock,
  brandBlock: BrandBlock,
  textBlock: PortableText,
  infoBlock: InfoBlock,
  allServices: AllServices,
  contactBlock: ContactBlock,
  announcement: Announcement,
  categoryBlock: AllCategories,
  brochureBlock: BrochureBlock,
  faq: Questions,
  serviceLevel: ServiceLevels,
};

const ContentBlocks = (type) => {
  const BlockNotFound = () => (
    <EmptyState title="Error: The requested component" message={type} />
  );
  if (typeof Blocks[type] === 'undefined') {
    return BlockNotFound;
  }
  return Blocks[type];
};

export default ContentBlocks;
